import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const FormModal = ({ open, onOpenChange, title, description, children, onSubmit, submitLabel = "Save", testid }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-[var(--surface-2)] border border-[color:var(--border-subtle)] max-w-lg" data-testid={testid}>
      <DialogHeader>
        <DialogTitle className="font-serif-display text-xl text-[var(--text)]">{title}</DialogTitle>
        <DialogDescription className="text-[var(--text-muted)]">
          {description || "Fill in the details below and save your changes."}
        </DialogDescription>
      </DialogHeader>
      <form
        onSubmit={(e) => { e.preventDefault(); onSubmit?.(); }}
        className="space-y-4"
      >
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">{children}</div>
        <DialogFooter className="gap-2">
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)}
            className="border-[color:var(--border-subtle)]">Cancel</Button>
          <Button type="submit" data-testid="form-submit-button"
            className="bg-[var(--green)] text-[#f7fbf9] hover:bg-[color:rgba(31,115,85,0.9)]">{submitLabel}</Button>
        </DialogFooter>
      </form>
    </DialogContent>
  </Dialog>
);

export const Field = ({ label, children, full, hint }) => (
  <div className={full ? "sm:col-span-2 space-y-1.5" : "space-y-1.5"}>
    <Label className="text-xs text-[var(--text-muted)]">{label}</Label>
    {children}
    {hint && <p className="text-[11px] text-[var(--text-faint)]">{hint}</p>}
  </div>
);

export const TextField = ({ label, full, hint, testid, ...props }) => (
  <Field label={label} full={full} hint={hint}>
    <Input {...props} data-testid={testid} className="bg-white border-[color:var(--border-subtle)]" />
  </Field>
);

export const NumberField = ({ label, full, hint, testid, ...props }) => (
  <Field label={label} full={full} hint={hint}>
    <Input type="number" step="any" {...props} data-testid={testid} className="bg-white border-[color:var(--border-subtle)] tabular-nums" />
  </Field>
);

export const TextArea = ({ label, full, testid, ...props }) => (
  <Field label={label} full={full}>
    <Textarea {...props} data-testid={testid} className="bg-white border-[color:var(--border-subtle)]" />
  </Field>
);

export const SelectField = ({ label, value, onChange, options, full, testid }) => (
  <Field label={label} full={full}>
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="bg-white border-[color:var(--border-subtle)]" data-testid={testid}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {options.map((o) => (
          <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  </Field>
);
